module.exports = __webpack_public_path__ + "static/media/broncos-silhouette.b4d92288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/broncos-silhouette.svg
// module id = 1324
// module chunks = 0